// A line of the guide's text as /docs draws it (docs.ts, byj-1wv.51.20), for
// the pages that say things the guide's way too — the template pages — so
// none of them imports the guide's page.
import { Fragment } from "react";
import { inline } from "../docs";
import { Link } from "./Nav";

/**
 * A line of the guide's text, its `code`, **bold** and [links](/to) drawn; a
 * page's own help says things this way too. A link to a place on the same
 * page (#machines) is followed in place; only one off the site opens a tab.
 * A page's help that points into the guide says /docs#machines.
 */
export function DocText({ s }: { s: string }) {
  return (
    <>
      {inline(s).map((r, i) =>
        r.kind === "code" ? (
          <code key={i}>{r.text}</code>
        ) : r.kind === "bold" ? (
          <strong key={i}>{r.text}</strong>
        ) : r.kind === "link" ? (
          r.href.startsWith("/") ? (
            <Link key={i} to={r.href}>
              {r.text}
            </Link>
          ) : r.href.startsWith("#") ? (
            <a key={i} href={r.href}>
              {r.text}
            </a>
          ) : (
            <a key={i} href={r.href} target="_blank" rel="noreferrer">
              {r.text}
            </a>
          )
        ) : (
          <Fragment key={i}>{r.text}</Fragment>
        ),
      )}
    </>
  );
}
